// Registry of forms that hold input the user has not saved (ENTRAID-342).
// Renewing the session is a full-page redirect that reloads the route, so the
// proactive renewal in lib/auth.js waits while anything is registered here and
// runs once the registry is clear (or on the next visibility change). Only
// forms that already track a dirty flag register; nothing here infers one.

const dirty = new Set();
const listeners = new Set();

export function setUnsavedChanges(key, isDirty) {
  const had = dirty.size > 0;
  if (isDirty) dirty.add(key);
  else dirty.delete(key);
  if (had && dirty.size === 0) for (const fn of [...listeners]) fn();
}

export function hasUnsavedChanges() {
  return dirty.size > 0;
}

/** Called whenever the registry goes from dirty to clear. Returns an unsubscribe. */
export function onUnsavedChangesCleared(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Test seam.
export function __resetUnsavedChangesForTests() {
  dirty.clear();
  listeners.clear();
}
